import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Form = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',

  '.MuiButton-contained': {
    marginTop: '28px',
    maxWidth: '410px',
  },

  [theme.breakpoints.down('sm')]: {
    '.MuiButton-contained': {
      marginTop: '20px',
    },
  },
}));

export const InputsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
  maxWidth: '410px',
  width: '100%',
  marginBottom: '18px',

  [theme.breakpoints.down('sm')]: {
    gap: '10px',
    marginBottom: '8px',
  },
}));
